<template>
  <div id="pdf-template-qr-codes-table">
    <span style="font-size:24px;bold">{{$t('pdf_template_texts_table.qr_codes')}}</span>
    <table cellpadding="0" cellspacing="0">
      <tr class="header-row" v-if="template.qr_codes.length > 0">
        <td
          v-for="(header, i) in headers"
          :key="i"
          :style="{ 'width': header.width + '%'}"
        >{{header.text}}</td>
      </tr>
      <tr v-for="(qrCode, i) in template.qr_codes" :key="i">
        <td>
          <input
            v-model="qrCode.x1"
            type="number"
            @keydown="joystick($event, qrCode, ['x1', 'y1'])"
          />
        </td>
        <td>
          <input
            v-model="qrCode.y1"
            type="number"
            @keydown="joystick($event, qrCode, ['x1', 'y1'])"
          />
        </td>
        <td>
          <input
            v-model="qrCode.width"
            type="number"
            @keydown="joystick($event, qrCode, ['width', 'height'])"
          />
        </td>
        <td>
          <input
            v-model="qrCode.height"
            type="number"
            @keydown="joystick($event, qrCode, ['width', 'height'])"
          />
        </td>
        <td>
          <v-icon small @click="deleteQrCode(i)">delete</v-icon>
        </td>
      </tr>
    </table>
    <button
      type="submit"
      class="btn btn-primary"
      @click="addQrCode"
    >{{$t('pdf_template_texts_table.add_qr_code')}}</button>
  </div>
</template>

<script>
import PdfTemplateQrCode from "@/models/PdfTemplateQrCode.js";
import Helper from "@/models/Helper.js";
export default {
  name: "pdf-template-qr-codes-table",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "X",
          width: 20,
        },
        {
          text: "Y",
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.width"),
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.height"),
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.actions"),
          with: 20,
        },
      ],
      defaultQrCode: {
        x1: 0,
        y1: 0,
        width: 50,
        height: 50,
      },
    };
  },
  methods: {
    addQrCode() {
      this.template.qr_codes.push(new PdfTemplateQrCode(this.defaultQrCode));
    },
    deleteQrCode(i) {
      this.template.qr_codes.splice(i, 1);
    },
    joystick(e, box, props) {
      Helper.joystick(e, box, props);
    },
  },
};
</script>

<style scoped>
input {
  border: 0px solid #000;
  margin: 0;
  background: transparent;
  width: 100%;
}
table tr td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
table {
  background: #fff none repeat scroll 0 0;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}
table tr:nth-child(even) {
  background: #ccc;
}
table tr:nth-child(odd) {
  background: #eee;
}
.header-row {
  font-weight: bold;
}
</style>